<form [formGroup]="prefaceForm()" *transloco="let t; prefix: 'registration.page.prefaceForm'">
  <htx-form-section [title]="t('title')" [icon]="'description'">
    <p class="preface-description">{{ t('description') }}</p>
    <htx-button icon="picture_as_pdf" (click)="openPdf('/assets/pdfs/HT-X-Teilnahmeerklaerung-v1.0.pdf')">
      {{ t('downloadTeilnahmeerklaerung') }}
    </htx-button>
    <htx-button icon="picture_as_pdf" (click)="openPdf('/assets/pdfs/HT-X-Beitrittsvereinbarung-v1.0t.pdf')">
      {{ t('downloadBeitrittsvereinbarung') }}
    </htx-button>
    <htx-checkbox-field-with-error
      [ctrl]="prefaceForm().controls['confirmation']"
      [label]="t('controls.confirmation.label')"
      [required]="true"
      [errorMessages]="{ required: '' }"
    >
    </htx-checkbox-field-with-error>
  </htx-form-section>
</form>
